import Preloader from "./js/components/preloader.js"
import Player from './js/components/player.js'
import Contact from "./js/components/contact.js"
import {
    debounce
} from 'throttle-debounce'
import {gsap, Power2} from "gsap"
class DelTorno {
    constructor() {
        this.preloader = new Preloader()
        this.contact = new Contact()
        this.setPlayer()
        this.events()
    }

    events() {
        const toTopBtn = document.querySelector("#to-top-btn")
        if (toTopBtn) {
            toTopBtn.addEventListener("click", (e) => {
                e.preventDefault()
                this.toTop()
            }, false)
        }
        let onResize = debounce(120, () => this.onResize())
        window.addEventListener("resize", (e) => onResize())
		this.onResize()
    }

    onResize() {
        this.imgs = document.querySelectorAll("img")
        this.imgs.forEach(img => {
            let _width = img.getBoundingClientRect().width
            if (img.classList.contains("small") || img.classList.contains("big")) {
                img.style.height = `${~~(_width)}px`
            } else if (img.classList.contains("horizontal")) {
                img.style.height = `${~~(_width / 2)}px`
            } else if (img.classList.contains("vertical")) {
                img.style.height = `${~~(_width * 2)}px`
            } else {
                img.style.height = `${~~(_width * .5625)}px`
            }
        })
        if (this.player) this.player.resize()
    }

    toTop() {
        if (this.isMobile()) {
            let obj = {
                y: window.scrollY
            }
            gsap.to(obj, {
                ease: Power2.easeOut,
                duration: .65,
                y: 0,
                onUpdate: () => {
                    window.scroll(0, obj.y)
                }
            })
        } else {
            return window.scroll(0,0)
        }
    }

    isMobile() {
        return MOBILE
    }

    setPlayer() {
        let player = document.querySelector("#video-container")
        if (player) this.player = new Player(player)
    }

    load() {
        this.preloader.hide()
        this.toTop()
    }
}
let _app = new DelTorno()
window.onload = () => {
    _app.load()
}